import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VersioneDTO } from '../../../models/versione.model';
import { DialogService } from '../../../services/dialog.service';
import { VersioneService } from '../../../services/versione.service';

@Component({
  selector: 'app-add-versions',
  templateUrl: './add-versions.component.html',
  styleUrls: ['./add-versions.component.scss']
})
export class AddVersionsComponent implements OnInit {

  title: string = '';
  versioneForm: UntypedFormGroup;
  versione: VersioneDTO = new VersioneDTO();
  
  constructor(
    public translate: TranslateService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private activateRoute: ActivatedRoute,
    private versioneService: VersioneService) { }

  ngOnInit(): void {
    // L'ID è presente, entro in modifica ricostruendo i dati dell'utente
    if (this.activateRoute.snapshot.params["id"] != null) {

      this.title = this.translate.instant("GENERIC_LABEL.EDIT");
      let currentID = Number(this.activateRoute.snapshot.params["id"]);

      this.versioneService.getVersioneByID(currentID)
        .then((res) => {
          this.versione = res;
          this.createForm();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    }
    else {
      // L'ID non è presente, entro in aggiunta
      this.title = this.translate.instant("GENERIC_LABEL.ADD");
      this.versione = new VersioneDTO();
      this.createForm();
    }
  }

  /**
   * Creazione del form dati
   **/
   createForm() {
    this.versioneForm = this.formBuilder.group({
      productName: [this.versione.ProductName, Validators.required],
      versionNumber: [this.versione.VersionNumber, Validators.required],
      releaseNotes: [this.versione.ReleaseNotes]
    });
  }
  
  /**
   * Salvataggio dei dati
   **/
  save() {
    if (this.versioneForm.invalid === true)
      return;

    this.versioneService.saveVersione(this.versione)
      .then((res) => {
        DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
        this.exit();
      })
      .catch((err) => {
        DialogService.Error(err.message);
      })
  }

  /**
   * Annulla l'operazione di aggiunta
   **/
  exit() {
    this.router.navigate(['/help']);
  }

}
